import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useShiftSlotsV2PageSize() {
  return useCbhFlag(CbhFeatureFlag.SHIFT_SLOTS_V2_PAGE_SIZE, {
    defaultValue: 10,
  });
}
